import React from 'react';
// Changed from 'react-dom/client' to 'react-dom' to ensure compatibility with react-snap hydration logic
import ReactDOM from 'react-dom'; 
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');

// Logic for React Snap Hydration
// If the DOM element already contains pre-rendered content (from react-snap),
// we use ReactDOM.hydrate to attach event listeners. Otherwise, we render normally.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrate(
    <React.StrictMode>
      <App />
    </React.StrictMode>, 
    rootElement
  );
} else {
  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>, 
    rootElement
  );
}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
